import React from 'react';

import MediaObject from 'components/MediaObject';
import TextWithIcon from 'components/TextWithIcon';
import Link from 'components/Link';
import Button from 'components/ButtonDeprecated';
import CoachingScheduleInstanceDescription from './CoachingScheduleInstanceDescription';
import { InstanceTextBadge } from 'coaching/components/CoachingHomeView/CoachingSessionInstanceRowComponents';
import { coachDashboardPrefix } from 'coaching/components/CoachDashboard';
import { GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach } from 'coaching/queries/__generated__/GetCoachDashboardScheduleInstances';

export type InstanceRowComponentProps = GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach;

export default function CoachingScheduleSessionRowInline(props: InstanceRowComponentProps) {
  const {
    startDateTime,
    endDateTime,
    participant,
    sessionSchedule,
    cancelled,
    cancelledLate,
    added,
    uuid: instanceUuid,
  } = props;
  return (
    <MediaObject figure="right" center>
      <MediaObject
        className="CoachingScheduleSessionRowInline"
        gutter="small"
        figure="right"
        inline>
        <CoachingScheduleInstanceDescription
          startDateTime={startDateTime}
          endDateTime={endDateTime}
          participantName={participant?.studentName ?? ''}
          studentGradeLevel={participant?.studentGradeLevel}
          subjectName={sessionSchedule?.subject?.name}
          isCancelled={cancelled}
        />
        <InstanceTextBadge
          textBadgeTextColorCancellation="apple"
          colorBadgeCancellation="apple-lightest"
          isLateCancelled={cancelledLate}
          isCancelled={cancelled}
          isPartOfRecurringSchedule={!added}
          userHasNoRecurringSchedules={!added}
        />
      </MediaObject>
      <Link
        eventKey={`${coachDashboardPrefix}.coach_dashboard_schedule.participant_stream.click`}
        eventProperties={{
          data: JSON.stringify({
            participant_uuid: participant?.uuid,
            schedule_uuid: sessionSchedule?.uuid,
            instance_uuid: instanceUuid,
          }),
        }}
        color="chalkboard"
        data-test="coaching-schedule-session-stream"
        to={`/coaching/messages/${participant?.sessionTools?.stream?.uuid}`}
        weight="semibold">
        <Button size="xxsmall" level="secondary" color="chalkboard">
          <TextWithIcon icon="message" iconSize="medium" size="xxxsmall">
            Message
          </TextWithIcon>
        </Button>
      </Link>
    </MediaObject>
  );
}
